export const SHIPIUM_DOCUMENTATION_URL = 'https://docs.shipium.com/docs';
export const SHIPIUM_DOCUMENTATION_CONTEXTS_SLUG = 'fulfillment-contexts';
